var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D3D",
    d: "M10 13.333A.833.833 0 1 0 10 15a.833.833 0 0 0 0-1.667Zm8.892 1.225L12.184 2.892a2.5 2.5 0 0 0-4.367 0L1.15 14.558a2.5 2.5 0 0 0 2.134 3.775h13.433a2.5 2.5 0 0 0 2.175-3.775Zm-1.442 1.667a.834.834 0 0 1-.733.425H3.284a.834.834 0 0 1-.734-.425.833.833 0 0 1 0-.833L9.217 3.725a.833.833 0 0 1 1.483 0l6.709 11.667a.833.833 0 0 1 .041.85v-.017ZM10 6.667a.833.833 0 0 0-.833.833v3.333a.833.833 0 0 0 1.667 0V7.5A.833.833 0 0 0 10 6.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.799fc6c0b8d92541ec0fffb9d5d3d1f6.svg";
export { ForwardRef as ReactComponent };